import { FC } from 'react';

import {
    AccountBalance as AccountBalanceIcon,
    Email as EmailIcon,
    LocationOn as LocationOnIcon,
    Person as PersonIcon,
    Smartphone as SmartphoneIcon,
} from '@mui/icons-material';
import { Grid } from '@mui/material';
import { renameKeys } from '@npi/buddy-utils';

import ContactItem from './ContactItem';

export type ContactInformation = {
    outletName?: string;
    firstName: string;
    lastName: string;
    email: string;
    mobilePhoneNumber: string;
    country: string;
    isBillingContact: boolean;
};

interface ContactProps {
    contactInformation?: ContactInformation;
    isMerchant?: boolean;
    activeStep?: string;
    hideBorderBottom?: boolean;
}

const Contact: FC<ContactProps> = ({
    contactInformation,
    isMerchant,
    activeStep,
    hideBorderBottom = false,
}: ContactProps) => {
    const contactData = isMerchant ? contactInformation : renameKeys(contactInformation);
    const dataTestId = `${activeStep}-contact`;

    return (
        <Grid
            data-testid={dataTestId}
            sx={{ borderTop: hideBorderBottom ? 'none' : '0.5px solid #DADADA' }}
        >
            {contactData.outletName && (
                <ContactItem
                    dataTestId={`${dataTestId}-outlet-name`}
                    icon={<AccountBalanceIcon sx={{ color: '#575757' }} />}
                    label="Outlet Name"
                    value={contactData?.outletName}
                    hideBorderBottom={hideBorderBottom}
                />
            )}
            <ContactItem
                dataTestId={`${dataTestId}-person-name`}
                icon={<PersonIcon sx={{ color: '#575757' }} />}
                label="Name"
                value={`${contactData?.firstName || '-'} ${contactData?.lastName || '-'}`}
                hideBorderBottom={hideBorderBottom}
            />
            <ContactItem
                dataTestId={`${dataTestId}-email`}
                icon={<EmailIcon sx={{ color: '#575757' }} />}
                label="Email"
                value={contactData?.email || '-'}
                hideBorderBottom={hideBorderBottom}
            />
            <ContactItem
                dataTestId={`${dataTestId}-number`}
                icon={<SmartphoneIcon sx={{ color: '#575757' }} />}
                label="Phone"
                value={contactData?.mobilePhoneNumber || '-'}
                hideBorderBottom={hideBorderBottom}
            />
            <ContactItem
                dataTestId={`${dataTestId}-location`}
                icon={<LocationOnIcon sx={{ color: '#575757' }} />}
                label="Address"
                value={contactData?.country || '-'}
                hideBorderBottom={hideBorderBottom}
            />
        </Grid>
    );
};

export default Contact;
